import { render, staticRenderFns } from "./DPHV.vue?vue&type=template&id=e13f9bd8&scoped=true"
import script from "./DPHV.vue?vue&type=script&lang=js"
export * from "./DPHV.vue?vue&type=script&lang=js"
import style0 from "./DPHV.vue?vue&type=style&index=0&id=e13f9bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13f9bd8",
  null
  
)

export default component.exports